import { render, staticRenderFns } from "./CompanyContactHome.vue?vue&type=template&id=e7b80d5e&scoped=true&"
import script from "./CompanyContactHome.vue?vue&type=script&lang=ts&"
export * from "./CompanyContactHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b80d5e",
  null
  
)

export default component.exports